/**
 * useLocalBusiness Hook
 * 
 * React Query hook for fetching Google Business Profile data.
 * Migrated from seo-engine-webtools-customer-module
 */

import { useQuery } from '@tanstack/react-query';
import { getLocalBusiness } from '@/services/customer/localBusinessApi';
import { LocalBusinessResponse } from '@/types/customer';
import { useSiteStore } from '@/store/site.store';

export interface UseLocalBusinessOptions {
  siteId?: number;
  enabled?: boolean;
}

export function useLocalBusiness(options: UseLocalBusinessOptions = {}) {
  const selectedSite = useSiteStore((state) => state.selectedSite);
  const siteId = options.siteId ?? selectedSite?.id ?? 1;

  return useQuery<LocalBusinessResponse, Error>({
    queryKey: ['customer-local-business', siteId],
    queryFn: () => getLocalBusiness(siteId),
    enabled: options.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export default useLocalBusiness;
